import cn from 'classnames'

import { CheckIcon } from '@components/icons/CheckIcon'
import { FollowButtonProps } from './interface'

export function FollowButton({
  className,
  isFollowed,
  hover,
  handleMouseFocus,
  handleMouseBlur,
  onClick,
}: FollowButtonProps) {
  return (
    <button
      className={cn(
        'flex items-center justify-center h-[40px] px-[30px] bg-primary dark:bg-purple font-mitr font-medium text-white dark:text-white-2 text-[14px] rounded-[40px]',
        {
          '!bg-white dark:!bg-dark-8 !text-primary border-primary border !px-[15px]':
            isFollowed,
          'desktop:!text-red desktop:border-red desktop:border':
            hover && isFollowed,
        },
        className
      )}
      type='button'
      onClick={onClick}
      onMouseOver={handleMouseFocus}
      onMouseOut={handleMouseBlur}
    >
      {hover && isFollowed ? (
        <>
          <span className='tablet-mobile:hidden desktop:pointer-events-none'>
            เลิกติดตาม
          </span>
          <CheckIcon
            className='mr-[5px] desktop:hidden'
            width='24'
            height='24'
          />
          <span className='desktop:hidden'>ติดตาม</span>
        </>
      ) : (
        <>
          {isFollowed && (
            <CheckIcon
              className='mr-[5px] desktop:pointer-events-none'
              width='24'
              height='24'
            />
          )}
          <span className='desktop:pointer-events-none'>ติดตาม</span>
        </>
      )}
    </button>
  )
}
